import React, { useState } from 'react'
import Modal from 'react-modal'
import { Box, IconButton } from 'theme-ui'
import { FaTimes } from 'react-icons/fa'
import menuApps from '../../../../../site/content/assets/flexiblocks/icons/menuApps.svg'
import './stylesApp.css'

const styles = {
  panelContent: {
    height: `100%`,
    zIndex: 2,
    overflowY: `scroll`,
    bg: `contentBg`,
    p: 3
  },
  openButton: {
    // display: ['', '', 'none'], //to avoid ssr rehydration issue
    verticalAlign: `middle`,
    color: '#ffffff'
  },
  closeButtonResponsive: {
    position: `fixed`,
    zIndex: 99999,
    left: `-35%`,
    top: 4,
    color: `white`
  }
}

const Drawer = ({ children, buttonStyle }) => {
  const [open, setOpen] = useState()
  const handleClick = () => setOpen(!open)

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{ ...styles.openButton, ...buttonStyle }}
        aria-label='Open Drawer'
      >
        <Box style={{ marginRight: '4rem'}}>
          <img src={menuApps} />
        </Box>
      </IconButton>
      <Modal
        isOpen={open}
        onRequestClose={handleClick}
        closeTimeoutMS={300}
        contentLabel='Drawer'
        className='DrawerPortalContentApps'
        overlayClassName='DrawerPortalOverlay'
      >
        <Box sx={styles.panelContent}>{children}</Box>
        <IconButton
          onClick={handleClick}
          sx={{ ...styles.closeButtonResponsive, ...buttonStyle }}
          aria-label='Close Drawer'
        >
          <FaTimes />
        </IconButton>
      </Modal>
    </>
  )
}

export default Drawer
